import React, { useState } from "react";
import "./SideBar.css";
// import Logo from "../../assets/logotest.png"

const SideBar = ({ darkMode, toggleDarkMode }) => {
  // Get the current year dynamically
  // console.log('text dark mode',darkMode);

  const currentYear = new Date().getFullYear();
  const [toggle, showMenu] = useState(false);

  return (
    <>
      <aside className={toggle ? "aside show-menu" : "aside"}>
        <a href="#home" className="nav__logo">
          {/* <img src={Logo} alt="" /> */}
        </a>
        <nav className="nav">
          <div className="nav__menu">
            <ul className="nav__list">
              {/* Dark mode */}
              <div className="nav__items">
              <li className={darkMode ? "app dark" : "app" }>
                  <button onClick={toggleDarkMode} className="dark-toggle-btn nav__link" >
                    {darkMode ? "⛅" : "🌜"}
                  </button>
              </li>
              </div>

              <li className="nav__items">
                <a href="#home" className="nav__link">
                  <i className="icon-home"></i>
                </a>
              </li>
              <li className="nav__items">
                <a href="#about" className="nav__link">
                  <i className="icon-user-following"></i>
                </a>
              </li>
              <li className="nav__items">
                <a href="#services" className="nav__link">
                  <i className="icon-briefcase"></i>
                </a>
              </li>
              <li className="nav__items">
                <a href="#resume" className="nav__link">
                  <i className="icon-graduation"></i>
                </a>
              </li>
              <li className="nav__items">
                <a href="#work" className="nav__link">
                  <i className="icon-layers"></i>
                </a>
              </li>
              {/* <li className="nav__items">
              <a href="#" className='nav__link'>
                <i className="icon-note"></i>
              </a>
            </li> */}
              <li className="nav__items">
                <a href="#contact" className="nav__link">
                  <i className="icon-bubble"></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div className="nav__footer">
          <span className="copyright">&copy; 2024 - {currentYear}</span>
        </div>
      </aside>

      <div
        className={toggle ? "nav__toggle nav__toggle-open" : "nav__toggle"}
        onClick={() => showMenu(!toggle)}
      >
        <i className="icon-menu"></i>
      </div>
    </>
  );
};

export default SideBar;
